import PreSvg from '../assets/pre.svg';

const Pre = () => {
  return (
    <div>
      <img src={PreSvg} alt="Pre SVG" />
    </div>
  );
};

export default Pre;
